module.exports = __webpack_public_path__ + "static/media/decrease.1a7b5542.svg";